export default __webpack_public_path__ + "static/media/webCam.daa7597d.svg";